import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=7036c5a5&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=7036c5a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7036c5a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7036c5a5')) {
      api.createRecord('7036c5a5', component.options)
    } else {
      api.reload('7036c5a5', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=7036c5a5&scoped=true&", function () {
      api.rerender('7036c5a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget-control/status/Index.vue"
export default component.exports